import { Divider, Typography } from "@mui/material";
import { DynamicFormBuilderContainer } from "../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.container";
import { FormItemTypes } from "../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity";
import { MuiStack } from "../../../components";
import StatusColor from "../../../components/atoms/statusColor";
import { faintblue, gray } from "../../../theme/palette";
import { getStatusBorderColor, getTextbgColor, getTextColor } from "../../preDeliveryInpection/entity";
var WarrantyTabMobView = function (props) {
    var id = props.id, onChange = props.onChange, value = props.value, error = props.error, _a = props.name, name = _a === void 0 ? 'ProprietaryWarrantyPartDetails' : _a;
    var warrantyDetails = [{
            type: FormItemTypes.ContainerItem,
            name: "warrantyDetails",
            label: "",
            value: null,
            columnSize: 12,
            elements: [{
                    type: FormItemTypes.List,
                    name: "warrantyDetails",
                    label: "",
                    variant: 'comfortable',
                    error: error === null || error === void 0 ? void 0 : error[name],
                    value: value,
                    disableCheckboxSelection: true,
                    columns: [{
                            field: 'Part',
                            flex: 1,
                            renderCell: function (params) {
                                return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Typography, {
                                    variant: "h3"
                                }, params.row.DisplayName), /*#__PURE__*/ React.createElement(Typography, {
                                    variant: "h6",
                                    color: "secondary"
                                }, params.row.SkuCode ? '#' + params.row.SkuCode : ''));
                            }
                        }],
                    elements: [{
                            type: FormItemTypes.Typography,
                            name: '',
                            children: /*#__PURE__*/ React.createElement(Divider, null),
                            sx: {
                                marginTop: "-7px"
                            },
                            columnSize: 12
                        }, {
                            type: FormItemTypes.CardComponent,
                            name: "",
                            variant: "outlined",
                            sx: {
                                backgroundColor: faintblue
                            },
                            columnSize: 12,
                            elements: [{
                                    type: FormItemTypes.ContainerItem,
                                    name: "",
                                    columnSize: 12,
                                    justifyContent: "space-between",
                                    elements: [{
                                            type: FormItemTypes.Typography,
                                            name: '',
                                            children: "Status :",
                                            variant: "h6",
                                            color: gray,
                                            columnSize: 0
                                        }, {
                                            type: FormItemTypes.Custom,
                                            name: '',
                                            label: '',
                                            value: null,
                                            columnSize: 0,
                                            element: function (params) {
                                                var _params$value, _params$value2, _params$value3, _params$value4;
                                                return /*#__PURE__*/ React.createElement(MuiStack, {
                                                    sx: {
                                                        border: "1px solid ".concat(getStatusBorderColor((_params$value = params.value) === null || _params$value === void 0 ? void 0 : _params$value.Name)),
                                                        borderRadius: "6px",
                                                        bgcolor: getTextbgColor((_params$value2 = params.value) === null || _params$value2 === void 0 ? void 0 : _params$value2.Name),
                                                        gap: "5px",
                                                        padding: "3px 8px"
                                                    },
                                                    alignItems: 'center',
                                                    margin: "5px"
                                                }, /*#__PURE__*/ React.createElement(StatusColor, {
                                                    status: (_params$value3 = params.value) === null || _params$value3 === void 0 ? void 0 : _params$value3.Name
                                                }), /*#__PURE__*/ React.createElement(Typography, {
                                                    id: "status-name",
                                                    color: getTextColor((_params$value4 = params.value) === null || _params$value4 === void 0 ? void 0 : _params$value4.Name),
                                                    sx: {
                                                        fontSize: '12px',
                                                        fontWeight: '500',
                                                        lineHeight: '18px',
                                                        width: 'max-content'
                                                    }
                                                }, "Pending"));
                                            }
                                        }]
                                }, {
                                    type: FormItemTypes.ContainerItem,
                                    name: "",
                                    label: "",
                                    value: null,
                                    columnSize: 12,
                                    justifyContent: "space-between",
                                    elements: [{
                                            type: FormItemTypes.Typography,
                                            name: '',
                                            children: "Created by:",
                                            variant: "h6",
                                            color: gray,
                                            columnSize: 0
                                        }, {
                                            type: FormItemTypes.Typography,
                                            name: '',
                                            children: "Michael Adams",
                                            variant: "h6",
                                            columnSize: 0
                                        }]
                                }]
                        }, {
                            type: FormItemTypes.TextInput,
                            name: 'PartGroup',
                            label: 'Part group',
                            value: null,
                            columnSize: 12,
                            required: true,
                            labelTypographyProps: {
                                variant: "h6",
                                color: gray
                            }
                        }, {
                            type: FormItemTypes.TextInput,
                            name: 'SerialNo',
                            label: 'Part serial no',
                            value: null,
                            columnSize: 6,
                            required: true,
                            labelTypographyProps: {
                                variant: "h6",
                                color: gray
                            }
                        }, {
                            type: FormItemTypes.SearchSelect,
                            name: "SupplierId",
                            label: "Vendor",
                            value: null,
                            required: true,
                            labelTypographyProps: {
                                variant: "h6",
                                color: gray
                            },
                            columnSize: 6
                        }, {
                            type: FormItemTypes.TextInput,
                            name: 'LocalVenderName',
                            label: 'Vendor dealer name',
                            value: null,
                            columnSize: 6,
                            required: true,
                            labelTypographyProps: {
                                variant: "h6",
                                color: gray
                            }
                        }, {
                            type: FormItemTypes.SearchSelect,
                            name: "DefectCodeId",
                            label: "Customer complaint",
                            value: null,
                            required: true,
                            labelTypographyProps: {
                                variant: "h6",
                                color: gray
                            },
                            columnSize: 6
                        }, {
                            type: FormItemTypes.SearchSelect,
                            name: "StatusId",
                            label: "Status ID",
                            value: null,
                            required: true,
                            labelTypographyProps: {
                                variant: "h6",
                                color: gray
                            },
                            columnSize: 6
                        }, {
                            type: FormItemTypes.DatePicker,
                            name: 'SettlementDate',
                            label: 'Claim settlement date',
                            placeholder: "From date",
                            value: null,
                            required: true,
                            labelTypographyProps: {
                                variant: "h6",
                                color: gray
                            },
                            columnSize: 6
                        }, {
                            type: FormItemTypes.TextInput,
                            name: 'Remarks',
                            label: 'Service advisor remarks',
                            value: null,
                            required: true,
                            columnSize: 12,
                            labelTypographyProps: {
                                variant: "h6",
                                color: gray
                            }
                        }],
                    columnSize: 12
                }]
        }];
    return /*#__PURE__*/ React.createElement(DynamicFormBuilderContainer, {
        formData: warrantyDetails,
        onChange: onChange
        // onClose={() => navigate("/pdiCheck")}
    });
};
export default WarrantyTabMobView;
